/**
 * 发起websocket请求函数
 * @param {object} wsObj  - ws对象
 *  @param {string} type  - 操作websocket：销毁close、创建create
 *  @param {number} timeout  - 心跳间隔时长，默认5000ms
 * @param sendHeartBeat  - 以心跳，内容体区分string、object
 * @param {function} msgCallback  - 接收到ws数据，对数据进行处理的回调函数
 * @param {function} reCallback  - ws每次重连时，暴露对外的回调函数
 */

const timeList = {} // 断开 重连倒计时
const timeoutObj = {} // 心跳倒计时
const params = {}
let currentWsName = ''
let currentType = ''
export function websocketCommand(data) {
    const { wsObj, type, msgCallback, sendHeartBeat = '{"cmd": "ping"}', timeout = 5000, wsName, reCallback } = data
    let wsDestroy = false //  销毁标志
    let lockReconnect = false // 是否真正建立连接
    currentType = type
    timeList[wsName] = null
    timeoutObj[wsName] = null
    params[wsName] = data
    currentWsName = wsName
    if (type !== 'warning' && type === 'close') {
        wsDestroy = true
        wsObj && wsObj.close()
        delete params[wsName]
        clearInterval(timeoutObj[wsName])
        clearInterval(timeList[wsName])
        delete timeoutObj[wsName]
        delete timeList[wsName]
    }
    if (type === 'create') {
        initWebsocket()
    }

    function initWebsocket() {
        if (typeof WebSocket === 'undefined') {
            // console.log('您的浏览器不支持WebSocket，无法获取数据')
            return false
        }
        wsObj.onmessage = function (e) {
            onMessage(e)
        }
        wsObj.onopen = function () {
            onOpen()
        }
        wsObj.onerror = function () {
            onError()
        }
        wsObj.onclose = function () {
            onClose()
        }
        websocketSend()
    }

    function websocketSend() {
        setTimeout(() => {
            // 添加状态判断，当为OPEN时，发送消息
            if (wsObj.readyState === wsObj.OPEN) {
                if (typeof sendHeartBeat === 'string') {
                    wsObj.send(sendHeartBeat)
                } else {
                    sendHeartBeat()
                }
            }
        }, 500)
    }

    function onMessage(evt) {
        const receivedMsg = evt && JSON.parse(evt.data)
        msgCallback(receivedMsg)
        window.dispatchEvent(
            new CustomEvent('onmessageWS', {
                detail: {
                    data: receivedMsg
                }
            })
        )
        start()
    }

    function onError() {
        // console.log('ws_error--断开重连....')
        // 断网重连机制
        if (!wsDestroy) {
            reconnect()
        }
    }

    function onOpen() {
        // console.log('ws_open')
        // 连接成功向服务器发送信息，并开启心跳
        websocketSend()
        start()
    }

    function reconnect() {
        // 避免重复建立连接
        // console.log('断开重连中......')
        if (lockReconnect) {
            return
        }
        lockReconnect = true
        // 没连接上会一直重连，设置延迟避免请求过多
        timeList[wsName] && clearTimeout(timeList[wsName])
        timeList[wsName] = setTimeout(function () {
            // 重连
            websocketCommand({
                wsObj: new WebSocket(data.wsObj.url),
                type: data.type,
                msgCallback: data.msgCallback,
                wsName: data.wsName
            })
            // 若重连后有需额外处理的逻辑，通过reCallback()回调暴露出去
            reCallback && reCallback()
            lockReconnect = false
        }, timeout)
    }

    function start() {
        // 清计时器
        timeoutObj[wsName] && clearInterval(timeoutObj[wsName])
        // 开启心跳
        timeoutObj[wsName] = setInterval(function () {
            if (wsObj.readyState === 1) {
                wsObj.send(sendHeartBeat)
            }
        }, timeout)
    }

    function onClose() {
        if (currentType !== 'close') {
            // 重连机制
            reconnect()
        } else if (wsObj.readyState === 1) {
            // console.log('ws_close', wsObj)
            // 如果ws连接正常，则清计时器、断开连接
            clearInterval(timeoutObj[wsName])
            wsObj && wsObj.close()
            delete params[wsName]
        }
    }
}

export const sendWSPush = (message, name) => {
    // console.log(params, name)
    if (params[name].wsObj !== null && params[name].wsObj.readyState === 3) {
        params[name].wsObj.close()
        websocketCommand({
            wsObj: new WebSocket(params[name].wsObj.url),
            type: params[name].type,
            msgCallback: params[name].msgCallback,
            wsName: params[name]
        })
    } else if (params[name].wsObj.readyState === 1) {
        // console.log('wssend=>', message)
        params[name].wsObj.send(JSON.stringify(message))
    } else if (params[name].wsObj.readyState === 0) {
        connecting(message)
    }
}

const connecting = (message) => {
    setTimeout(() => {
        if (params[currentWsName].wsObj.readyState === 0) {
            connecting(message)
        } else {
            params[currentWsName].wsObj.send(JSON.stringify(message))
        }
    }, 1000)
}
